export default "__VITE_ASSET__iVjaoI8Z__"